@if (miniNavigation()) {
  <div class="row mt-3">
    <div class="mininavigation" [ngClass]="{ show: dropdownOpen() }">
      <button type="button" class="mininavigation__toggle" id="mininavigation__dropdown" (click)="toggleDropdown()">
        <span i18n="@@jumpTo">Jump to</span>
        <i class="fas fa-chevron-down"></i>
      </button>
      <ul class="mininavigation__list" aria-labelledby="mininavigation__dropdown" [ngClass]="{ show: dropdownOpen() }">
        @for (navigationItem of miniNavigation(); track $index) {
          @if (navigationItem.anchorId && navigationItem.title) {
            <li class="mininavigation__item" (click)="dropdownOpen.set(false); $event.stopPropagation()">
              <a class="w-auto" [fragment]="navigationItem.anchorId" [routerLink]="[]"> {{ navigationItem.title }}</a>
            </li>
          }
        }
      </ul>
    </div>
  </div>
}
